import { Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useState } from 'react';
import clsx from 'clsx';
import { AddBrands } from '../form/AddBrands';
import { KTSVG } from '../../../../../../_metronic/helpers';
import { UsePageDataManagerResult } from '../hooks/usePageDataManager';
import { SiService } from '../../../mappings';
import { SiAiAddBrands } from '../form/SiAiAddBrands';

type Props = {
  data: {
    [SiService.BRAND_DETECT_SERVICE]: any;
    [SiService.CATEGORIZE_SERVICE]: any;
  };
  show: boolean;
  isSiAiNewData: boolean;
  handleClose: () => void;
  handleUpdate: UsePageDataManagerResult['updateField'];
  handleSaveMultiple: UsePageDataManagerResult['saveMultipleServices'];
  handleRefetchImages: () => void;
};

const AddBrandsModal: React.FC<Props> = ({
  data,
  show,
  isSiAiNewData,
  handleClose,
  handleUpdate,
  handleSaveMultiple,
  handleRefetchImages,
}) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Modal
      id='add_brands_modal'
      aria-hidden='true'
      tabIndex={-1}
      dialogClassName='modal-dialog-centered mw-1000px h-auto'
      show={show}
    >
      <div className={clsx('container-xxl px-5', isLoading && 'overlay overlay-block')}>
        <div className='modal-body'>
          <div className='overlay-wrapper'>
            {/* Header */}
            <div className='w-100 d-flex justify-content-between mt-5 mb-3'>
              <div>
                <h1 className='d-flex align-items-center text-dark fw-bolder fs-1 ms-md-12'>
                  Add Brands
                </h1>
              </div>
              <div className='btn btn-icon btn-sm btn-light-primary me-md-9' onClick={handleClose}>
                <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
              </div>
            </div>
            {isSiAiNewData ? <SiAiAddBrands
              data={data}
              onClose={handleClose}
              onUpdate={handleUpdate}
              onSaveMultiple={handleSaveMultiple}
              handleRefetchImages={handleRefetchImages}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            /> : <AddBrands
              data={data}
              onClose={handleClose}
              onUpdate={handleUpdate}
              onSaveMultiple={handleSaveMultiple}
              handleRefetchImages={handleRefetchImages}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />}
          </div>

          {/* Loading overlay blocker */}
          {isLoading && <div className='overlay-layer bg-white bg-opacity-10 z-index-3'></div>}
        </div>
      </div>
    </Modal>
  );
};
export { AddBrandsModal };
